const hasRequiredListItemFields = (category) => {
  return Boolean(category.name && category.key);
};
export {
  hasRequiredListItemFields
};
//# sourceMappingURL=types.js.map
